import { BasicInfoStep } from 'modules/trainings/components/Revamp/NewFormWizard/BasicInfoStep'
import { FormTypeStep } from 'modules/trainings/components/Revamp/NewFormWizard/FormTypeStep'
import { FormWizardData } from 'modules/trainings/components/Revamp/NewFormWizard/types'
import { AvailableSections } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/EditMode/editionOptions'

type Props = {
  selected: string
  onDataChange: (data: FormWizardData) => void
  data: FormWizardData
  loading: boolean
}

export const FormEditMode = ({ selected, onDataChange, data, loading }: Props) => {
  switch (selected) {
    case AvailableSections.basic:
    default:
      return <BasicInfoStep data={data} onDataChanged={onDataChange} completed loading={loading} />
    case AvailableSections.type:
      return (
        <FormTypeStep
          completed
          onDataChanged={onDataChange}
          data={data}
          loading={loading}
          disabled
        />
      )
  }
}
